import { Component } from 'react';
import { asField } from 'informed';
import { breakpoints } from 'styles';
import { PictureSelector } from 'components/common';
import { FileUploader } from 'components/common/uploader';
import { SettingsPicturePreview } from '.';

export default asField(
  class extends Component {
    state = {
      picture: this.props.fieldState.value ? this.props.fieldState.value : null,
      preview: null
    };

    handleSelect = (picture) => {
      this.setState({ picture });
      this.props.fieldApi.setValue(picture);
      if (this.props.onChange) this.props.onChange(picture);
    };

    handleFileRemoved = () => {
      this.setState({ preview: null });
      this.props.onPictureRemoved();
    };

    handleFileAdded = () => {
      this.props.onPictureAdded();
    };

    handleThumbnailGenerated = ({ preview }) => {
      this.setState({ preview });
    };

    handleUploadSuccess = ({ filename, url }) => {
      this.props.fieldApi.setValue(url);
      if (this.props.onChange) this.props.onChange(url);
      this.props.onPictureUpload();
    };

    render() {
      const { picturePosition } = this.props;

      return (
        <div className="picture">
          <div className="selectors">
            <div className="upload">
              <FileUploader
                allowedFileTypes={['image/*']}
                getUploader={this.props.setUploader}
                id="course-settings-picture"
                keyPrefix="uploads/images/original/"
                onFileAdded={this.handleFileAdded}
                onFileRemoved={this.handleFileRemoved}
                onThumbnailGenerated={this.handleThumbnailGenerated}
                onUploadSuccess={this.handleUploadSuccess}
                uuidAsFilename={true}
              />
            </div>

            <div className="pictures">
              <PictureSelector
                onSelect={this.handleSelect}
                picturePosition={picturePosition}
                selectedPicture={this.state.picture}
              />
            </div>
          </div>

          <SettingsPicturePreview
            picture={this.state.preview || this.state.picture}
            picturePosition={picturePosition}
            size={480}
          />

          <style jsx>{`
            .selectors {
              align-items: flex-end;
              display: flex;
            }
            .selected {
              border-radius: 3px;
              height: 100px;
              margin-right: 30px;
              overflow: hidden;
              position: relative;
              width: 200px;
            }
            .options {
              display: flex;
              flex-wrap: wrap;
              margin: -6px 2px;
              padding: 5px;
              width: 220px;
            }
            .option {
              flex-basis: 50%;
              padding: 4px;
            }
            .options button.option-button {
              background-color: white;
              border: 4px solid white;
              border-radius: 3px;
              min-width: 0;
              padding: 0;
              transition: background-color 0.3s, border-color 0.3s;
            }
            .options button.option-button:hover,
            .options button.option-button:active {
              background-color: #ccc;
              border-color: #ccc;
            }
            .options button.option-button.active {
              background-color: #555;
              border-color: #555;
            }
            .option-content {
              background-color: white;
              border-radius: 3px;
              height: 42px;
              overflow: hidden;
              position: relative;
            }
            .upload {
              margin-right: 15px;
            }
            @media (min-width: ${breakpoints.medium}px) {
              .options {
                width: 380px;
              }
              .option {
                flex-basis: 25%;
              }
            }
          `}</style>
        </div>
      );
    }
  }
);
